import {
  DiscountDetail,
  DiscountTemplateOption,
} from "@/types/billing/discount";

import { requestData } from "@/api/api-config";

/**
 * List non-archived discount templates as {id, label} options (for cohort
 * filters / discount pickers).
 */
export async function listDiscountTemplateOptions(): Promise<
  DiscountTemplateOption[] | null
> {
  return requestData<DiscountTemplateOption[]>(
    "billing/discount-templates",
    "get",
  );
}

/**
 * Get all active discounts for a patient
 */
export async function getPatientDiscounts(
  patientId: string,
  includeExpired = false,
  memberId?: string,
  soldPackageId?: string,
  includeArchived = false,
): Promise<DiscountDetail[] | null> {
  const searchParams: Record<string, string | boolean> = {
    include_expired: includeExpired,
    include_archived: includeArchived,
  };
  if (memberId) {
    searchParams.member_id = memberId;
  }
  if (soldPackageId) {
    searchParams.sold_package_id = soldPackageId;
  }
  return requestData<DiscountDetail[]>(
    `billing/discounts/patient/${patientId}`,
    "get",
    { searchParams },
  );
}

export async function updatePackageDiscount(
  discountId: string,
  update: { quantityRemaining: number; comment: string | null },
): Promise<DiscountDetail | null> {
  return requestData<DiscountDetail>(
    `billing/discounts/package-discount/${discountId}`,
    "put",
    {
      json: {
        quantityRemaining: update.quantityRemaining,
        comment: update.comment,
      },
    },
  );
}
